import script from "./Layout5.vue?vue&type=script&lang=ts&setup=true"
export * from "./Layout5.vue?vue&type=script&lang=ts&setup=true"

import "./Layout5.vue?vue&type=style&index=0&id=29ef91b1&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29ef91b1"]])

export default __exports__